import Chart from 'chart.js';

export default {
  init() {
    // JavaScript to be fired on the Masterplan page

    // Chart Default Styles
    // Chart.defaults.global.defaultFontFamily = 'Roboto';
    Chart.defaults.global.defaultFontColor = '#111';
    if ($(window).width() < 960) {
      Chart.defaults.global.defaultFontSize = 8;
    } else {
      Chart.defaults.global.defaultFontSize = 14;
    }

    // Chart Colors
    var chartColors = {
      red: 'rgb(167, 39, 55)',
      blue: 'rgb(14, 94, 193)',
      green: 'rgb(160, 165, 143)',
      lt_green: 'rgb(192, 195, 183)',
      white: 'rgb(255, 255, 255)',
    };

    // Tooltip Styles
    var tooltipOptions = {
      enabled: true,
      titleFontColor: '#111',
      bodyFontColor: '#111',
      backgroundColor: '#fff',
      cornerRadius: 0,
      borderColor: '#ddd',
      borderWidth: 1,
    };

    // All Years
    var labelYears = ['12 months', '30 months', '48 months'];

    // System Dimensions
    var config = {
      type: 'line',
      data: {
        labels: labelYears,
        datasets: [
          {
            label: 'ORIGINAL PLAN',
            backgroundColor: chartColors.green,
            borderColor: chartColors.green,
            data: [60, 500],
            fill: false,
            lineTension: 0,
            spanGaps: true,
          },
          {
            label: 'REVISED PLAN',
            fill: false,
            backgroundColor: chartColors.blue,
            borderColor: chartColors.blue,
            data: [60, 160, 500],
            lineTension: 0,
            spanGaps: true,
          },
        ],
      },
      options: {
        responsive: true,
        layout: {
          padding: {
            left: 50,
            right: 50,
            top: 50,
            bottom: 50,
          },
        },
        title: {
          display: false,
        },
        tooltips: tooltipOptions,
        scales: {
          xAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Time',
              },
            },
          ],
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Housing Units Constructed',
              },
            },
          ],
        },
      },
    };

    var ctx = document.getElementById('systemDimensions').getContext('2d');
    window.myLine = new Chart(ctx, config);

    $(document).ready(function () {
      $.ajax({
        url: 'https://www.googleapis.com/youtube/v3/commentThreads?part=snippet%2Creplies&videoId=wtLJPvx7-ys&maxResults=2&key=AIzaSyCGp2A_IcXcWSnn_A8P33hAkGKotC-3GlE',
        complete: function (response) {
          console.log(response.responseText);
        },
      });
      return false;
    });

    $('.masterPlanSlider').slick({
      dots: true,
      infinite: true,
      speed: 800,
      slidesToShow: 1,
      customPaging: function (slider, i) {
        var thumb = $(slider.$slides[i]).data('thumb');
        return '<a>' + thumb + '</a>';
      },
      adaptiveHeight: true,
      easing: 'linear',
    });

    $('.next-nav').click(function () {
      $('.masterPlanSlider').slick('slickNext');
    });

    $('.prev-nav').click(function () {
      $('.masterPlanSlider').slick('slickPrev');
    });

    // VIDEOS
    $.ajax({
      url: '../youtube.json',
      type: 'GET',
      dataType: 'json',
      success: function (data) {
        for (var i = 0, len = data.length; i < len; i++) {
          // var id = data[i]['id'];
          var title = data[i]['title'];
          var video = data[i]['video'];
          var image = data[i]['image'];
          var summary =
            '<div class="video-slide"><a class="video-link" rel="relativeanchor" href="#mainVid"><div class="thumb" id="' +
            video +
            '" style="background: url(' +
            image +
            ') no-repeat center; background-size:cover;"><div class="overlay-text"><p>WATCH</p></div></div><p>' +
            title +
            '</p></a></div>';
          $('#videos').append(summary);

          $('.thumb').click(function (e) {
            e.preventDefault();
            var url =
              'https://player.vimeo.com/video/' +
              $(this).attr('id') +
              '?title=1&amp;byline=1&amp;portrait=1&amp;autoplay=1';
            var iframe = $(
              '<iframe width="100%" height="700px" frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen=""/>'
            ).attr('src', url);
            $('#mainVid').html(iframe);
          });
        }
      },
      complete: function () {
        $('.videoSlider').slick({
          rtl: false, // If RTL Make it true & .slick-slide{float:right;}
          autoplay: false,
          infinite: true,
          speed: 800, // Transition Speed
          slidesToShow: 4, // Number Of Carousel
          slidesToScroll: 4, // Slide To Move
          pauseOnHover: false,
          appendArrows: $('.slider-wrap .arrows'), // Class For Arrows Buttons
          prevArrow:
            '<span class="Slick-Prev"><i class="ion-ios-arrow-thin-left"></i></span>',
          nextArrow:
            '<span class="Slick-Next"><i class="ion-ios-arrow-thin-right"></i></span>',
          easing: 'linear',
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '60px',
              },
            },
            {
              breakpoint: 481,
              settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '60px',
              },
            },
          ],
        });
      },
    });
  },
  finalize() {
    // JavaScript to be fired on the Masterplan page, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/masterplan.js